import { useQuery } from '@tanstack/react-query';
import {
  MarketplacePerformanceService,
  UseHeaderInfoValues,
} from 'modules/marketplace-performance-page/api/marketplacePerformanceService';

const queryKeys = {
  STATS_INFO: 'stats-info',
};

export const useStatsInfo = ({ botId }: UseHeaderInfoValues) => {
  const {
    data: stats,
    error: statsError,
    isLoading: isLoadingStats,
  } = useQuery({
    queryKey: [queryKeys.STATS_INFO, botId],
    queryFn: () => MarketplacePerformanceService.getStatsInfo({ botId }),
  });

  return {
    stats,
    statsError,
    isLoadingStats,
  };
};
